/**
 * tdesign v1.8.0
 * (c) 2024 tdesign
 * @license MIT
 */

var props = {
  checkboxProps: {
    type: Object
  },
  checked: {
    type: Array,
    "default": void 0
  },
  defaultChecked: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  data: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  direction: {
    type: String,
    "default": "both",
    validator: function validator(val) {
      if (!val) return true;
      return ["left", "right", "both"].includes(val);
    }
  },
  disabled: {
    type: [Boolean, Array]
  },
  empty: {
    type: [String, Array, Function],
    "default": ""
  },
  footer: {
    type: [Array, Function]
  },
  keys: {
    type: Object
  },
  operation: {
    type: [Array, Function]
  },
  pagination: {
    type: [Object, Array]
  },
  search: {
    type: [Boolean, Object, Array],
    "default": false
  },
  showCheckAll: {
    type: [Boolean, Array],
    "default": true
  },
  targetDraggable: Boolean,
  targetSort: {
    type: String,
    "default": "original",
    validator: function validator(val) {
      if (!val) return true;
      return ["original", "push", "unshift"].includes(val);
    }
  },
  title: {
    type: [Array, Function],
    "default": function _default() {
      return [];
    }
  },
  transferItem: {
    type: Function
  },
  value: {
    type: Array,
    "default": void 0
  },
  modelValue: {
    type: Array,
    "default": void 0
  },
  defaultValue: {
    type: Array,
    "default": function _default() {
      return [];
    }
  },
  onChange: Function,
  onCheckedChange: Function,
  onPageChange: Function,
  onScroll: Function,
  onSearch: Function
};

export { props as default };
//# sourceMappingURL=props.mjs.map
